module.exports = __webpack_public_path__ + "img/logo_gatra.e1e0931c.png";